import { sortByName } from 'utils';

import { OBJECT_TYPES } from 'enum/object';
import { CLEAR_DATA } from '../common-action-types';
import * as ACTION_TYPES from './action-types';

const initialState = {
  isLoading: true,
  success: true,
  createdObject: null,
  psk: '',
  imgGenerating: {},
  address: [],
  things: [],
  initialObjectLoaded: false,
};

export function objectsReducer(state = initialState, { type, payload }) {
  switch (type) {
    case ACTION_TYPES.SET_INITIAL_OBJECT_LOADED: {
      return {
        ...state,
        initialObjectLoaded: payload,
      };
    }
    case ACTION_TYPES.GET_BASIC_OBJECTS_SUCCESS: {
      return {
        ...state,
        [payload.ecosystemUUID]: {
          ...(state[payload.ecosystemUUID] ? state[payload.ecosystemUUID] : {}),
          objects: payload.objects,
        },
      };
    }
    case ACTION_TYPES.SET_THINGS: {
      return {
        ...state,
        [payload.ecosystemUUID]: {
          ...(state[payload.ecosystemUUID] ? state[payload.ecosystemUUID] : {}),
          objects: {
            ...state[payload.ecosystemUUID]?.objects,
            things: sortByName(payload.things.map((thing) => ({ ...thing, element: OBJECT_TYPES.THING }))),
          },
        },
      };
    }
    case ACTION_TYPES.CREATE_THING: {
      const { result, ecosystemUUID } = payload;

      return {
        ...state,
        [ecosystemUUID]: {
          ...state[ecosystemUUID],
          objects: {
            ...state[ecosystemUUID]?.objects,
            things: sortByName([
              ...(state[ecosystemUUID]?.objects?.things || []),
              { ...result, element: OBJECT_TYPES.THING },
            ]),
          },
        },
      };
    }
    case ACTION_TYPES.UPDATE_THING: {
      const { result, ecosystemUUID } = payload;

      return {
        ...state,
        [ecosystemUUID]: {
          ...state[ecosystemUUID],
          objects: {
            ...state[ecosystemUUID]?.objects,
            things: state[ecosystemUUID]?.objects?.things.map((thing) =>
              thing.uuid === result.uuid ? { ...result, element: OBJECT_TYPES.THING } : thing,
            ),
          },
        },
      };
    }
    case ACTION_TYPES.DELETE_THING: {
      const { uuid, ecosystemUUID } = payload;

      return {
        ...state,
        [ecosystemUUID]: {
          ...state[ecosystemUUID],
          objects: {
            ...state[ecosystemUUID]?.objects,
            things: state[ecosystemUUID]?.objects?.things.filter((thing) => thing.uuid !== uuid),
          },
        },
      };
    }
    case ACTION_TYPES.UPDATE_THING_TOKEN: {
      const { token, ecosystemUUID, uuid } = payload;
      return {
        ...state,
        [ecosystemUUID]: {
          ...state[ecosystemUUID],
          objects: {
            ...state[ecosystemUUID]?.objects,
            things: state[ecosystemUUID]?.objects?.things.map((thing) =>
              thing.uuid === uuid ? { ...thing, token } : thing,
            ),
          },
        },
      };
    }

    case ACTION_TYPES.SET_ADDRESSES: {
      return {
        ...state,
        [payload.ecosystemUUID]: {
          ...(state[payload.ecosystemUUID] ? state[payload.ecosystemUUID] : {}),
          objects: {
            ...state[payload.ecosystemUUID]?.objects,
            addresses: sortByName(payload.addresses.map((address) => ({ ...address, element: OBJECT_TYPES.ADDRESS }))),
          },
        },
      };
    }
    case ACTION_TYPES.CREATE_ADDRESS: {
      const { result, ecosystemUUID } = payload;

      return {
        ...state,
        [ecosystemUUID]: {
          ...state[ecosystemUUID],
          objects: {
            ...state[ecosystemUUID]?.objects,
            addresses: sortByName([
              ...(state[ecosystemUUID]?.objects?.addresses || []),
              { ...result, element: OBJECT_TYPES.ADDRESS },
            ]),
          },
        },
      };
    }
    case ACTION_TYPES.UPDATE_ADDRESS: {
      const { result, ecosystemUUID } = payload;

      return {
        ...state,
        [ecosystemUUID]: {
          ...state[ecosystemUUID],
          objects: {
            ...state[ecosystemUUID]?.objects,
            addresses: state[ecosystemUUID]?.objects?.addresses.map((address) =>
              address.uuid === result.uuid ? { ...result, element: OBJECT_TYPES.ADDRESS } : address,
            ),
          },
        },
      };
    }
    case ACTION_TYPES.DELETE_ADDRESS: {
      const { uuid, ecosystemUUID } = payload;
      return {
        ...state,
        [ecosystemUUID]: {
          ...state[ecosystemUUID],
          objects: {
            ...state[ecosystemUUID]?.objects,
            addresses: state[ecosystemUUID]?.objects?.addresses.filter((address) => address.uuid !== uuid),
          },
        },
      };
    }

    case ACTION_TYPES.SET_GATEWAYS: {
      const { ecosystemUUID, gateways } = payload;
      return {
        ...state,
        [ecosystemUUID]: {
          ...(state[ecosystemUUID] ? state[ecosystemUUID] : {}),
          objects: {
            ...state[ecosystemUUID]?.objects,
            gateways: sortByName(gateways.map((gateway) => ({ ...gateway, element: OBJECT_TYPES.GATEWAY }))),
          },
        },
      };
    }
    case ACTION_TYPES.CREATE_GATEWAY: {
      const { result, ecosystemUUID } = payload;

      return {
        ...state,
        [ecosystemUUID]: {
          ...state[ecosystemUUID],
          objects: {
            ...state[ecosystemUUID]?.objects,
            gateways: sortByName([
              ...(state[ecosystemUUID]?.objects?.gateways || []),
              { ...result, element: OBJECT_TYPES.GATEWAY },
            ]),
          },
        },
      };
    }
    case ACTION_TYPES.UPDATE_GATEWAY: {
      const { result, ecosystemUUID } = payload;
      return {
        ...state,
        [ecosystemUUID]: {
          ...state[ecosystemUUID],
          objects: {
            ...state[ecosystemUUID]?.objects,
            gateways: state[ecosystemUUID]?.objects?.gateways.map((gateway) =>
              gateway.uuid === result.uuid ? { ...result, element: OBJECT_TYPES.GATEWAY } : gateway,
            ),
          },
        },
      };
    }
    case ACTION_TYPES.DELETE_GATEWAY: {
      const { uuid, ecosystemUUID } = payload;
      return {
        ...state,
        [ecosystemUUID]: {
          ...state[ecosystemUUID],
          objects: {
            ...state[ecosystemUUID]?.objects,
            gateways: state[ecosystemUUID]?.objects?.gateways.filter((gateway) => gateway.uuid !== uuid),
          },
        },
      };
    }

    case ACTION_TYPES.GET_THINGS_SUCCESS: {
      return {
        ...state,
        things: payload,
      };
    }
    case ACTION_TYPES.GENERATE_IMAGE_STARTED: {
      return {
        ...state,
        imgGenerating: {
          ...state.imgGenerating,
          [payload.uuid]: {
            ...state.imgGenerating[payload.uuid],
            [payload.platform]: true,
          },
        },
      };
    }
    case ACTION_TYPES.GENERATE_IMAGE_SUCCESS:
    case ACTION_TYPES.GENERATE_IMAGE_FAILURE:
      return {
        ...state,
        imgGenerating: {
          ...state.imgGenerating,
          [payload.uuid]: {
            ...state.imgGenerating[payload.uuid],
            [payload.platform]: false,
          },
        },
      };

    case ACTION_TYPES.CREATE_POLICY_OBJECT: {
      return {
        ...state,
        createdObject: { object: payload.object, field: payload.field },
      };
    }
    case ACTION_TYPES.REGEN_PSK_SUCCESS: {
      return {
        ...state,
        psk: payload.psk,
      };
    }
    case ACTION_TYPES.GET_LDAP_TOKEN_SUCCESS: {
      return {
        ...state,
        [payload.ecosystemUUID]: {
          ...(state[payload.ecosystemUUID] ? state[payload.ecosystemUUID] : { objects: {} }),
          ldapToken: payload.token,
        },
      };
    }
    case CLEAR_DATA: {
      return initialState;
    }
    default:
      return state;
  }
}
